<script setup>
const props = defineProps({
  filterOptions: {
    type: Object,
    default: null,
  },
  checkNumeric: {
    type: Function,
    default: null,
  },
  aggregationForm: {
    type: Object,
    default: null,
  },
});
const emit = defineEmits(['close', 'save']);

const state = reactive({
  form: props.aggregationForm,
});

const available_keys = computed(() => {
  return Object.keys(props.filterOptions).map(key => ({ label: key, value: key }));
});

function getAggregationOptions() {
  const key = state.form?.property || available_keys.value[0]?.value;
  const values = props.filterOptions[key];
  const options = [{ label: 'Count', value: 'count' }];
  if (props.checkNumeric(values)) {
    options.push({ label: 'Sum', value: 'sum' });
    options.push({ label: 'Average', value: 'avg' });
    options.push({ label: 'Minimum', value: 'min' });
    options.push({ label: 'Maximum', value: 'max' });
    options.push({ label: 'Median', value: 'median' });
  }
  return options;
}

function onSave() {
  const data = {
    property: state.form.property,
    aggregation: state.form.aggregation,
    prefix: state.form.prefix || '',
    suffix: state.form.suffix || '',
  };
  emit('save', data);
}
</script>

<template>
  <hawk-modal-container id="filter-configure-popup" :width="600" content_class="rounded-lg max-w-[600px]">
    <Vueform
      v-model="state.form"
      :columns="{
        lg: {
          container: 12,
          label: 4,
          wrapper: 12,
        },
      }"
      sync size="sm" :display-errors="false" :endpoint="onSave"
    >
      <div class="col-span-12">
        <hawk-modal-header @close="emit('close')">
          <template #title>
            <div class="flex items-center">
              {{ $t('Configure values') }}
            </div>
          </template>
        </hawk-modal-header>
        <hawk-modal-content>
          <SelectElement
            name="property"
            class="mb-6"
            :label="$t('Property')"
            :placeholder="$t('Select')"
            :native="false"
            :items="available_keys"
            :default="available_keys?.[0]?.value"
            :rules="['required']"
            :can-clear="false"
            :can-deselect="false"
            :search="true"
            append-to="#filter-configure-popup"
            @select="state.form.aggregation = getAggregationOptions()[0].value"
          />
          <SelectElement
            name="aggregation"
            class="mb-6"
            :label="$t('Aggregation')"
            :placeholder="$t('Select')"
            :native="false"
            :items="getAggregationOptions()"
            :default="getAggregationOptions()?.[0]?.value"
            :rules="['required']"
            :can-clear="false"
            :can-deselect="false"
            append-to="#filter-configure-popup"
          />

          <TextElement
            name="prefix"
            :label="$t('Prefix')"
            :placeholder="$t('Enter prefix')"
            class="w-full mb-6"
          />
          <TextElement
            name="suffix"
            :label="$t('Suffix')"
            :placeholder="$t('Enter suffix')"
            class="w-full mb-6"
          />
        </hawk-modal-content>
        <hawk-modal-footer>
          <template #right>
            <div class="flex justify-end gap-4">
              <HawkButton type="outlined" @click="emit('close')">
                {{ $t('Close') }}
              </HawkButton>
              <ButtonElement
                button-class="w-full bg-blue-600" name="submit" :submits="true"
              >
                {{ $t('Save') }}
              </ButtonElement>
            </div>
          </template>
        </hawk-modal-footer>
      </div>
    </Vueform>
  </hawk-modal-container>
</template>

<style scoped lang="scss">

</style>
